function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Router"
}, /*#__PURE__*/React.createElement("title", null, "VF_router_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M226.8 42.5c12.6 0 25.1 2.1 37 6.2l14.2-25c-33-12.7-69.5-12.7-102.5 0l14.3 24.9c11.9-4 24.4-6.1 37-6.1zM197 61.3l14.5 25.5c10-2.2 20.4-2.2 30.5 0l14.5-25.5c-19.3-6.1-40.1-6.1-59.5 0zM283.5 177.2H241v-78h-28.3v78H0v106.3h283.5V177.2zm-28.4 77.9l-226.8.1v-49.7h226.8v49.6z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "53.1",
  cy: "230.3",
  r: "10.6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "81.5",
  cy: "230.3",
  r: "10.6"
}))));